export default __webpack_public_path__ + "static/media/welpentreffen_13.29501d15.jpg";